import {
  ERROR_CIRCUITS_BY_CUSTOMER_ID, ERROR_CIRCUITS_BY_USER_ID,
  LOADING_CIRCUITS_BY_CUSTOMER_ID, LOADING_CIRCUITS_BY_USER_ID,
  SUCCESS_CIRCUITS_BY_CUSTOMER_ID, SUCCESS_CIRCUITS_BY_USER_ID,
} from '../../const/actionTypes';
import { ICustomerCircuit } from '../../interfaces/customerCircuid';
import { EPackageType } from '../../interfaces/packageType';
import { IUsageData } from '../../interfaces/usageData';

interface IInitialState {
  loading: boolean;
  circuits: ICustomerCircuit[];
  error: string;
  packageTypes: EPackageType[];
  usageData?: IUsageData;
}

const initialState: IInitialState = {
  loading: false,
  circuits: [],
  error: '',
  packageTypes: [],
  usageData: undefined,
};

export type DashboardState = Readonly<typeof initialState>;

const dashboardReducer = (
  state = initialState,
  action: any
): DashboardState => {
  switch (action.type) {
    case LOADING_CIRCUITS_BY_CUSTOMER_ID: {
      return {
        ...state,
        loading: true,
      };
    }

    case SUCCESS_CIRCUITS_BY_CUSTOMER_ID: {
      return {
        ...state,
        loading: false,
        circuits: action.payload.data,
        packageTypes: action.payload.packageTypes,
      };
    }

    case ERROR_CIRCUITS_BY_CUSTOMER_ID: {
      return {
        ...state,
        loading: false,
      };
    }
    case LOADING_CIRCUITS_BY_USER_ID: {
      return {
        ...state,
        loading: true,
      };
    }

    case SUCCESS_CIRCUITS_BY_USER_ID: {
      return {
        ...state,
        loading: false,
        circuits: action.payload.data,
        packageTypes: action.payload.packageTypes,
      };
    }

    case ERROR_CIRCUITS_BY_USER_ID: {
      return {
        ...state,
        loading: false,
      };
    }

    default:
      return state;
  }
};

export default dashboardReducer;
